// [BD feat] Product gallery mouse drag-to-pan — bd-product-gallery.js
// snippets/product-gallery.liquid's <scroll-carousel> deliberately does NOT set theme.js's
// [allow-drag] (assets/theme.js ScrollCarousel): that mouseup handler snaps via the carousel's
// private targetIndex, which gets thrown off mid-drag by this carousel's adaptive-height
// re-measuring, and its click-suppression-after-drag doesn't stop the product gallery's own
// click-to-advance handler (theme.js ProductGallery onCarouselClick_fn) from also firing on
// release — the same class of bug documented in assets/bd-search-drawer.js for the search
// drawer's carousel. This file gives 1:1 mouse panning instead, and lets the carousel's own
// scroll-snap-type: x mandatory (theme.css .product-gallery__carousel) settle it on release,
// exactly like native touch scrolling already does.
(function () {
  'use strict';

  var pointerFine = window.matchMedia('screen and (pointer: fine)');

  function initScope(scope) {
    if (!scope || !scope.querySelectorAll) return;
    var galleries = scope.querySelectorAll('product-gallery');
    if (!galleries.length) return;

    galleries.forEach(function (gallery) {
      if (gallery.hasAttribute('data-bd-drag-init')) return;

      var carousel = gallery.querySelector('.product-gallery__carousel');
      if (!carousel) return;

      gallery.setAttribute('data-bd-drag-init', '');

      var dragged = false;
      var startX = 0;
      var startScrollLeft = 0;

      function onMouseMove(event) {
        var delta = event.clientX - startX;
        if (Math.abs(delta) > 3) dragged = true;
        carousel.scrollLeft = startScrollLeft - delta;
      }

      function onMouseUp() {
        carousel.classList.remove('is-dragging');
        carousel.style.removeProperty('scroll-snap-type');
        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', onMouseUp);
      }

      carousel.addEventListener('mousedown', function (event) {
        if (event.button !== 0 || !pointerFine.matches) return;
        dragged = false;
        startX = event.clientX;
        startScrollLeft = carousel.scrollLeft;
        carousel.style.setProperty('scroll-snap-type', 'none');
        carousel.classList.add('is-dragging');
        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
      });

      // A drag that moved the cursor shouldn't also trigger the click-to-advance cursor
      // (theme.js ProductGallery onCarouselClick_fn) on release. Listening on the capture
      // phase at the gallery (an ancestor of the carousel) guarantees this runs before that
      // handler, which is registered directly on the carousel for the bubble phase.
      gallery.addEventListener('click', function (event) {
        if (dragged) {
          event.preventDefault();
          event.stopImmediatePropagation();
          dragged = false;
        }
      }, true);
    });
  }

  initScope(document);

  // Shopify theme editor support: re-init when the section is re-rendered
  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target || !event.target.querySelector) return;
    if (!event.target.querySelector('product-gallery')) return;
    initScope(event.target);
  });
})();
// [/BD feat] Product gallery mouse drag-to-pan
